const register = {
  loginCredentials: "ข้อมูลรับรองการเข้าสู่ระบบ", // translated
  companyInformation: "ข้อมูล บริษัท", // translated
  contactDetails: "รายละเอียดการติดต่อ", // translated
  businessName: "ชื่อธุรกิจ", // translated
  businessAddress: "ที่อยู่ บริษัท", // translated
  registrationCode: "รหัสลงทะเบียน", // translated
  businessRegistrationNumber: "หมายเลขทะเบียนธุรกิจ", // translated
  websiteUrl: "URL ของเว็บไซต์", // translated
  mobilePhone: "โทรศัพท์มือถือ", // translated
  regionStateProvince: "ภูมิภาค/รัฐ/จังหวัด", // translated
  legalTitle: "ชื่อทางกฎหมาย", // translated
  city: "เมือง", // translated
  postalCode: "รหัสไปรษณีย์", // translated
  registrationSuccess: "การลงทะเบียนสำเร็จ", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "กรุณารอสักครู่แล้วคุณจะถูกนำไปที่หน้าแรก", // translated
  usernameEmail: "ชื่อผู้ใช้ (อีเมล)", // translated
  password: "รหัสผ่าน", // translated
  verifyPassword: "ยืนยันรหัสผ่าน", // translated
  documents: "เอกสาร", // translated
  termsAndConditionsSection: "ข้อกำหนดและเงื่อนไข", // translated
  certificateOfIncorporation: "หนังสือรับรองการจดทะเบียน", // translated
  acceptTermsAndConditions: "ยอมรับข้อกำหนดและเงื่อนไข", // translated
  country: "ประเทศ", // translated
  brandName: "ชื่อแบรนด์", // translated
  register: "ลงทะเบียน", // translated
  isRequired: "จำเป็นต้องระบุ", // translated
  passwordMin8Chars: "ต้องมีอย่างน้อย 8 ตัวอักษร", // translated
  passwordRequiresDigit: "ต้องมีตัวเลขอย่างน้อย 1 ตัว", // translated
  passwordRequiresLowercase: "ต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว", // translated
  passwordRequiresUppercase: "ต้องมีตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัว", // translated
  passwordRequiresSpecialChar: 'ต้องมีอักขระพิเศษอย่างน้อย 1 ตัว (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "อัปโหลดไฟล์", // translated
  filename: "ชื่อไฟล์:", // translated
  fileType: "ประเภท:", // translated
  fileSize: "ขนาด:", // translated
  maxFileSize10Mb: "สูงสุด: 10MB", // translated
  supportedFileTypes: "ประเภทไฟล์ที่รองรับ:", // translated
  showPassword: "แสดงรหัสผ่าน", // translated
  hidePassword: "ซ่อนรหัสผ่าน", // translated
  notAvailable: "ไม่มี", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "เช่น +66812345678", // translated
  websiteUrlPlaceholder: "http://www.example.com", // translated
  loading: "กำลังโหลด...", // translated
  uploadingDocument: "กำลังอัปโหลดเอกสาร...", // translated
  percentUploaded: "อัปโหลดแล้ว {{percent}}%", // translated
  registrationSuccessful: "ลงทะเบียนสำเร็จ", // translated
  failedToUploadDocument: "อัปโหลดเอกสารไม่สำเร็จ", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}} ต้องยาวกว่า {{min}} ตัวอักษร", // translated
  fieldMustBeValidEmail: "{{field}} ต้องเป็นอีเมลที่ถูกต้อง", // translated
  fieldPasswordMinLength: "{{field}} ต้องมีอย่างน้อย 8 ตัวอักษร", // translated
  fieldPasswordRequiresDigit: "{{field}} ต้องมีตัวเลขอย่างน้อย 1 ตัว", // translated
  fieldPasswordRequiresLowercase: "{{field}} ต้องมีตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัว", // translated
  fieldPasswordRequiresUppercase: "{{field}} ต้องมีตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัว", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} ต้องมีอักขระพิเศษอย่างน้อย 1 ตัว (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}} ไม่ตรงกับ {{otherField}}", // translated
  fieldBetweenLength: "{{field}} ต้องมีความยาวระหว่าง {{min}} ถึง {{max}} ตัวอักษร", // translated
  postalCodeBetweenLength: "{{field}} ต้องมีความยาวระหว่าง {{min}} ถึง {{max}} ตัวอักษร", // translated
  invalidUrlFormat: "รูปแบบ URL ไม่ถูกต้อง", // translated
  invalidEmailFormat: "รูปแบบอีเมลไม่ถูกต้อง", // translated
  emailMustMatchUsername: "อีเมลต้องตรงกับชื่อผู้ใช้ (อีเมล)", // translated
  mobilePhoneIsRequired: "ต้องระบุเบอร์มือถือ", // translated
  certificateFileTooLarge: "ไฟล์หนังสือรับรองมีขนาดใหญ่เกินไป", // translated
  termsMustBeAccepted: "ต้องยอมรับข้อกำหนดและเงื่อนไข", // translated
};


export default register;
